import {Component, inject, Input, SimpleChanges} from '@angular/core';
import {NgForOf, NgIf} from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {CommunicationCenterService} from "@modules/communication-center";
import {EventService} from "shared/event.service";

@Component({
    selector: 'app-freemium-reward-progress-bar',
    standalone: true,
    imports: [
        NgIf,
        NgForOf,
        TranslateModule,
        ],
    templateUrl: './freemium-reward-progress-bar.component.html'
})
export class FreemiumRewardProgressBarComponent {
    @Input() segments = 3;
    @Input() triggersCount = 0;

    animatedPercent = 0;

    dotPositions: number[] = [];
    lessonsRemaining = 0;
    isCompleted = false;

    private shakeIntervalId: any = null;
    isShaking = false;
    private communicationCenter = inject(CommunicationCenterService);
    private eventService = inject(EventService);

    ngOnChanges(changes: SimpleChanges) {
        this.triggersCount = changes?.triggersCount?.currentValue;
        this.segments = Math.max(2, Math.floor(this.segments || 3));
        // Calculate dot positions (exclude start and end)
        this.dotPositions = [];
        for (let i = 1; i < this.segments; i++) {
            this.dotPositions.push((i / this.segments) * 100);
        }

        const clampedTriggers = Math.max(0, Math.min(this.triggersCount, this.segments));
        this.lessonsRemaining = Math.max(0, this.segments - clampedTriggers);
        this.isCompleted = clampedTriggers >= this.segments;
        const targetPercent = (clampedTriggers / this.segments) * 100;
        this.playFillAnimation(targetPercent);
        this.setupShakeInterval();
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        if (this.shakeIntervalId) {
            clearInterval(this.shakeIntervalId);
        }
    }

    private playFillAnimation(targetPercent: number) {
        this.animatedPercent = 0;
        setTimeout(() => {
            this.animatedPercent = targetPercent;
        }, 500);
    }

    private setupShakeInterval() {
        if (this.shakeIntervalId) {
            clearInterval(this.shakeIntervalId);
            this.shakeIntervalId = null;
        }
        if (this.isCompleted) {
            this.triggerShakeOnce();
            this.shakeIntervalId = setInterval(() => this.triggerShakeOnce(), 30000);
        }
    }

    private triggerShakeOnce() {
        this.isShaking = false;
        setTimeout(() => {
            this.isShaking = true;
        }, 50);
        setTimeout(() => {
            this.isShaking = false;
        }, 2200);
    }

    onPremiumClick() {
        this.eventService.trackEvent('open modal',  'trial period', 'premium');
        this.communicationCenter
            .getRoom('freemium-premium')
            .getSubject('access-premium-display-reverse-trial-modal')
            .next(true);
    }
}